import React, { useCallback, useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import surveyService from '../../services/survey.service';
import Loading from '../common/Loading';
import EcxSurveyEditor from '../helpers/ecxsurvey/EcxSurveyEditor';
import { useSurveyStore } from '../helpers/ecxsurvey/surveyutilities/surveyStore';

function ClinicSurveyEdit() {
    const { clinicId, surveyId } = useParams();
    const loadSurveyData = useSurveyStore((state) => state.loadSurveyData);
    const exportToJSON = useSurveyStore((state) => state.exportToJSON);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    const loadSurvey = useCallback(() => {
        setLoading(true);
        setError(null);

        surveyService
            .getSurveyById(clinicId, surveyId)
            .then((res) => {
                loadSurveyData({
                    survey: res.data.survey,
                    questions: res.data.questions || [],
                });
            })
            .catch((err) => {
                console.error(err);
                setError('Failed to load clinic survey. Please try again.');
            })
            .finally(() => setLoading(false));
    }, [clinicId, surveyId, loadSurveyData]);

    useEffect(() => {
        loadSurvey();
    }, [loadSurvey]);

    const handleSave = async () => {
        try {
            const surveyData = exportToJSON();
            await surveyService.updateClinicSurvey(clinicId, surveyId, surveyData);
            toast.success('Clinic survey updated successfully!');
        } catch (err) {
            console.error(err);
            toast.error(err.response?.data?.message || 'Failed to update clinic survey. Please try again.');
        }
    };

    if (error) {
        return (
            <div className="container-fluid px-3 px-lg-4">
                <div className="pagetitle d-flex justify-content-between align-items-center flex-wrap gap-2">
                    <h1 className="mb-0">
                        <i className="bi bi-ui-checks-grid"></i> Clinic Survey
                    </h1>
                    <Link to={`/clinics/${clinicId}`} className="btn btn-sm btn-outline-secondary">
                        <i className="bi bi-chevron-left me-1"></i>
                        Back to Clinic
                    </Link>
                </div>
                <div className="alert alert-warning border-0 shadow-sm">{error}</div>
            </div>
        );
    }

    return (
        <div className="container-fluid px-3 px-lg-4">
            <div className="pagetitle d-flex justify-content-between align-items-center flex-wrap gap-2 mb-3">
                <h1 className="mb-0">
                    <i className="bi bi-ui-checks-grid"></i> Edit Clinic Survey
                </h1>
                <Link to={`/clinics/${clinicId}`} className="btn btn-sm btn-outline-secondary">
                    <i className="bi bi-chevron-left me-1"></i>
                    Back to Clinic
                </Link>
            </div>
            {loading ? <Loading /> : <EcxSurveyEditor onSave={handleSave} />}
        </div>
    );
}

export default ClinicSurveyEdit;
